import React from 'react'

import {
  BucketListDetailsPlaceholder,
  BucketListPlaceholder,
  EscapeRow,
} from './display'

type LoadingProps = { type: 'bookings' | 'bucketLists' }

const Loading = ({ type }: LoadingProps) => (
  <>
    {[...Array(4)].map((_, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <EscapeRow key={`${type}-loading-${i}`}>
        <BucketListPlaceholder />
        <BucketListDetailsPlaceholder />
      </EscapeRow>
    ))}
  </>
)

export default Loading
